import { render } from "./ScpmAccordionItem.vue?vue&type=template&id=521880e8&scoped=true"
import script from "./ScpmAccordionItem.vue?vue&type=script&lang=js"
export * from "./ScpmAccordionItem.vue?vue&type=script&lang=js"

import "./ScpmAccordionItem.vue?vue&type=style&index=0&id=521880e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521880e8"],['__file',"src/components/scpm/common/ScpmAccordionItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "521880e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('521880e8', __exports__)) {
    api.reload('521880e8', __exports__)
  }
  
  module.hot.accept("./ScpmAccordionItem.vue?vue&type=template&id=521880e8&scoped=true", () => {
    api.rerender('521880e8', render)
  })

}


export default __exports__